/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

function Pengalaman() {
  return (
    <section>
      <div className="lg:pl-10 md:h-full px-10 py-5">
        <h1 className="text-center font-bold text-2xl lg:pt-10 lg:text-left text-gradient-primary uppercase">
          Pengalaman & Kegiatan
        </h1>
        <div className="w-24 h-1 bg-gradient-accent rounded-full mx-auto lg:mx-0 mt-3 mb-8"></div>
        <div className="lg:relative lg:overflow-y-auto lg:scrollbar-hide lg:max-h-[700px] md:pb-32 lg:pb-44">
          <div className="md:pl-10">
            <ol className="list-decimal list-outside">
              {/* start Pengalaman Kerja */}
              <li className="pt-4 font-bold text-lg">Pengalaman Kerja</li>
              <ol className="relative border-l border-gray-200">
                <ul className="mb-5 ml-4">
                  <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3"></div>
                  <time className="mb-1 text-sm font-normal leading-none text-gray-400">
                    Januari 2025 - Sekarang
                  </time>
                  <li className="text-base font-medium">
                    <i>Middle Front End Developer </i> - Badan Teknologi, Informasi, dan Intelijen Keuangan (BaTii)
                  </li>
                  <ul className="pl-4 list-decimal text-sm">
                    <li>Melakukan pembangunan pengembangan sistem aplikasi area Frontend</li>
                    <li>Melakukan identifikasi dan analisis gangguan layanan sistem aplikasi area Frontend</li>
                    <li>Melakukan pemulihan gangguan layanan sistem aplikasi area Frontend</li>
                    <li>Melakukan analisis dan evaluasi pemulihan gangguan layanan sistem aplikasi area Frontend</li>
                    <li>Melakukan review dan analisis kode program area Frontend</li>
                    <li>Melalukan analisis kinerja sistem aplikasi area Frontend</li>
                  </ul>
                </ul>

                <ul className="mb-5 ml-4">
                  <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3"></div>
                  <time className="mb-1 text-sm font-normal leading-none text-gray-400">
                    Juli 2022 - Desember 2024
                  </time>
                  <li className="text-base font-medium">
                    <i>Jr. Front End Developer </i> - Pusat Informasi dan Sistem Teknologi Keuangan
                  </li>
                  <ul className="pl-4 list-decimal text-sm">
                    <li>Melakukan pembangunan pengembangan sistem aplikasi area Frontend</li>
                    <li>Melakukan identifikasi dan analisis gangguan layanan sistem aplikasi area Frontend</li>
                    <li>Melakukan pemulihan gangguan layanan sistem aplikasi area Frontend</li>
                    <li>Melakukan analisis dan evaluasi pemulihan gangguan layanan sistem aplikasi area Frontend</li>
                  </ul>
                </ul>

                <ul className="mb-5 ml-4">
                  <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3"></div>
                  <time className="mb-1 text-sm font-normal leading-none text-gray-400">
                    April 2022 - Mei 2022
                  </time>
                  <li className="text-base font-medium">
                    <i>Front End Developer </i> - RSUD Dr. H. Mohamad Rabain
                  </li>
                  <p className="text-xs">
                    Menjadi seorang <i>Front End Developer</i> dengan <i>slicing</i> tampilan untuk Display Panggilan dan Nomor Antrian Rumah Sakit Dr. H. Mohamad Rabain.
                  </p>
                </ul>

                <ul className="mb-5 ml-4">
                  <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3"></div>
                  <time className="mb-1 text-sm font-normal leading-none text-gray-400">
                    April 2019 - Juli 2019
                  </time>
                  <li className="text-base font-medium">
                    <i>Front End Developer </i> - Ricko Rental dan Ratu Sikumbang Rental
                  </li>
                  <p className="text-xs">
                    Menjadi seorang <i>Freelance Website </i> untuk membuat sebuah portofolio.
                  </p>
                </ul>

                <ul className="mb-5 ml-4">
                  <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3"></div>
                  <time className="mb-1 text-sm font-normal leading-none text-gray-400">
                    Desember 2018 - Januari 2019
                  </time>
                  <li className="text-base font-medium">
                    <i>Front End Developer </i> - PT. Pos Indonesia (Persero) Regional III Kota Palembang
                  </li>
                  <p className="text-xs">
                    Menjadi Seorang <i>Front End Developer </i> dalam pengembangan sebuah <a className="italic">website </a> Sistem Analisis Kas Kecil operasional (KKO).
                  </p>
                </ul>
              </ol>
              {/* End Pengalaman Kerja */}

              {/* Start Pengalaman Organisasi */}
              <li className="pt-4 font-bold text-lg">Pengalaman Organisasi</li>
              <ol className="relative border-l border-gray-200">
                <ul className="mb-5 ml-4">
                  <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3"></div>
                  <time className="mb-1 text-sm font-normal leading-none text-gray-400">
                    2017 - 2018
                  </time>
                  <li className="text-base font-medium">DPM KM FASILKOM UNSRI</li>
                  <p className="text-sm">Staff Khusus Badan Musyawarah</p>
                </ul>
              </ol>
              {/* End Pengalaman Organisasi */}

              {/* Start Pengalaman Eksternal */}
              <li className="pt-4 font-bold text-lg">Kegiatan Eksternal</li>
              <ol className="relative border-l border-gray-200">
                <ul className="mb-5 ml-4">
                  <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3"></div>
                  <time className="mb-1 text-sm font-normal leading-none text-gray-400">
                    1 Desember 2025 - 7 Desember 2025
                  </time>
                  <li className="text-base font-medium">Hackathon - Inovasi AI: Mendorong Usaha Lokal Dengan AI Inklusif</li>
                  <p className="text-sm">IMPHNEN & Kolosal AI</p>
                </ul>

                <ul className="mb-5 ml-4">
                  <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3"></div>
                  <time className="mb-1 text-sm font-normal leading-none text-gray-400">
                    15 April 2022 - 31 Mei 2022
                  </time>
                  <li className="text-base font-medium">Belajar Dasar Pemrograman Web</li>
                  <p className="text-sm">Dicoding</p>
                </ul>

                <ul className="mb-5 ml-4">
                  <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3"></div>
                  <time className="mb-1 text-sm font-normal leading-none text-gray-400">
                    29 Maret 2022 - 2 April 2022
                  </time>
                  <li className="text-base font-medium">Pelatihan <i>Junior Web Developer </i></li>
                  <p class="text-sm">Digitalent Kominfo</p>
                </ul>

                <ul className="mb-5 ml-4">
                  <div className="absolute w-3 h-3 bg-gray-200 rounded-full mt-1.5 -left-1.5 border border-[#F3F3F3"></div>
                  <time className="mb-1 text-sm font-normal leading-none text-gray-400">
                    Juni 2021 - Agustus 2021
                  </time>
                  <li className="text-base font-medium">Pelatihan Pemrograman Website Dasar </li>
                  <p className="text-sm">Bootcamp Camp404</p>
                </ul>
              </ol>
            </ol>
            {/* End Pengalaman Eksternal */}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pengalaman; 